<example-shell
  exampleId="server-pagination" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Server pagination simulation"
    [columns]="orderColumns"
    [data]="serverRows"
    [pagination]="true"
    [paginationServer]="true"
    [paginationTotalRows]="orders.length"
    [paginationDefaultPage]="serverPage"
    [paginationPerPage]="serverRowsPerPage"
    [paginationRowsPerPageOptions]="pageSizes"
    (pageChange)="changeServerPage($event)"
    (rowsPerPageChange)="changeServerRowsPerPage($event)">
  </stackline-data-table>
</example-shell>
